import {contentTiersDropdown} from '@graphql/contentTier';
import {contentCategoriesFilteredByLevelAndParentsQuery} from '@graphql/content';

export const contentBody = `
    id
    tournament {
        id
        name
        tournament_category {
            id
            name
            sport {
                id
                name
            }
        }
    }
    content_category {
        id
        name
        parent {
            id
            name
        }
    }
    content_tier {
        id
        name
    }
`;

export const propertyLicenceContentTypeOtherDropdownData = `
query PropertyLicenceContents($parents : [Int], $level: Int) {
    ${contentTiersDropdown}
    ${contentCategoriesFilteredByLevelAndParentsQuery}
}`;

export const propertyLicenceContentUpdateMutation = `
mutation
  updatePropertyLicenceContent(
    $id: ID!
    $content_tier: Int!
  ) {
      updatePropertyLicenceContent(
        id: $id
        content_tier: $content_tier
      ) {
        ${contentBody}
      }
    }

`;

export const propertyLicenceContentDeleteMutation = `
mutation deletePropertyLicenceContent($id : ID!) {
    deletePropertyLicenceContent(id : $id)
}
`;
